import { makeStyles } from '@material-ui/core/styles';
import { darken, lighten, alpha } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme) => {
    const isLightTheme = theme.palette.type === 'light';
    const hoverColor = isLightTheme
        ? darken(alpha(theme.palette.background.paper, 1), 0.03)
        : lighten(alpha(theme.palette.background.paper, 1), 0.06);
    const selectionBackgroundColor = isLightTheme
        ? darken(alpha(theme.palette.background.paper, 1), 0.06)
        : lighten(alpha(theme.palette.background.paper, 1), 0.03);

    const selectionColor = isLightTheme ? theme.palette.primary.main : theme.palette.primary.light;

    return {
        root: {
            '& .MuiAccordion-root': {
                transition: 'none',
            },

            '& .MuiAccordion-root.Mui-expanded': {
                margin: 0,

                '&:before': {
                    opacity: 1,
                },

                '& + .MuiAccordion-root:before': {
                    display: 'block',
                },
            },

            '& .MuiAccordionSummary-root': {
                padding: '0 12px',
                minHeight: 38,
                transition: 'none',

                '&:hover': {
                    backgroundColor: hoverColor,
                },
            },

            '& .MuiAccordionSummary-root.Mui-expanded': {
                minHeight: 38,
            },

            '& .MuiAccordionSummary-content': {
                ...theme.mixins.flex.alignItemsCenter,
                margin: '8px 0',
                transition: 'none',
                color: theme.palette.text.secondary,
                fontSize: 14,
                fontWeight: 500,
            },

            '& .MuiAccordionSummary-expandIcon': {
                padding: 8,
            },

            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: '8px 0',
            },

            '& .MuiList-padding': {
                paddingTop: 0,
                paddingBottom: 20,
            },

            '& .MuiListItem-root, & .MuiAccordionSummary-root': {
                padding: '0 12px 0 9px',
                borderLeft: '3px solid',
                borderColor: theme.palette.background.paper,
                height: 38,
                cursor: 'pointer',

                '&:hover': {
                    backgroundColor: hoverColor,
                    borderColor: hoverColor,
                },

                '&.Mui-selected': {
                    color: isLightTheme ? selectionColor : theme.palette.text.primary,
                    borderColor: selectionColor,
                    backgroundColor: selectionBackgroundColor,

                    '&:hover': {
                        backgroundColor: selectionBackgroundColor,
                    },

                    '& a, & .MuiListItemIcon-root': {
                        color: selectionColor,
                    },
                },

                '& a': {
                    ...theme.mixins.flex.displayInlineFlex,
                    ...theme.mixins.flex.alignItemsCenter,
                    ...theme.mixins.flex.grow(1),
                    color: theme.palette.text.primary,
                    overflow: 'hidden',

                    '&:hover': {
                        textDecoration: 'none',
                    },
                },

                '& .MuiListItemIcon-root': {
                    minWidth: 30,

                    '& .MuiSvgIcon-root': {
                        fontSize: 22,
                    },
                },

                '&$historyItem': {
                    '& .MuiListItemIcon-root': {
                        minWidth: 20,

                        '& .MuiSvgIcon-root': {
                            fontSize: 12,
                        },
                    },
                },

                '& .MuiListItemText-primary': {
                    fontSize: 14,
                    fontWeight: 500,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },

                '& $actions': {
                    marginLeft: theme.spacing(0.5),
                    marginRight: theme.spacing(-0.5),
                    visibility: 'hidden',
                },

                '&:hover $actions, &.Mui-selected $actions': {
                    visibility: 'visible',
                },
            },
        },
        historyGroup: {
            '& .MuiList-padding': {
                padding: 0,
            },
        },
        historyItem: {
            '& a': {
                paddingLeft: 30,
            },
        },
        actions: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexWrapNowrap,
            ...theme.mixins.flex.justifyContentFlexEnd,
            ...theme.mixins.flex.grow(1),
            marginRight: theme.spacing(-1),

            '& .MuiIconButton-root': {
                padding: 0,

                '&:hover': {
                    background: 'none',
                },
            },

            '& svg': {
                fill: theme.palette.grey[400],
            },

            '& svg:hover': {
                fill: 'currentColor',
            },
        },
        draggable: {
            cursor: 'grab',
        },
        dragging: {
            visibility: 'hidden',
        },
    };
});

export default useStyles;
